export const setUserInfo = (info: { token: string; role: string }) => {
  localStorage.setItem("userInfo", JSON.stringify(info || {}));
};
export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem("userInfo") || "{}");
};
export const removeUserInfo = () => {
  localStorage.removeItem("userInfo");
};

// 账号列表管理
interface AccountInfo {
  phone: string;
  name?: string;
  role?: string;
  lastLoginTime: number;
}

const ACCOUNT_LIST_KEY = "accountList";
const MAX_ACCOUNT_COUNT = 5; // 最多保存5个账号

// 获取账号列表
export const getAccountList = (): AccountInfo[] => {
  try {
    const list = localStorage.getItem(ACCOUNT_LIST_KEY);
    return list ? JSON.parse(list) : [];
  } catch {
    return [];
  }
};

// 保存账号到列表
export const saveAccountToList = (account: {
  phone: string;
  name?: string;
  role?: string;
}) => {
  try {
    let accountList = getAccountList();

    // 移除已存在的相同账号
    accountList = accountList.filter((item) => item.phone !== account.phone);

    // 添加到列表开头
    accountList.unshift({
      ...account,
      lastLoginTime: Date.now(),
    });

    // 限制数量
    if (accountList.length > MAX_ACCOUNT_COUNT) {
      accountList = accountList.slice(0, MAX_ACCOUNT_COUNT);
    }

    localStorage.setItem(ACCOUNT_LIST_KEY, JSON.stringify(accountList));
  } catch (error) {
    console.error("保存账号列表失败:", error);
  }
};

// 从列表移除账号
export const removeAccountFromList = (phone: string) => {
  try {
    let accountList = getAccountList();
    accountList = accountList.filter((item) => item.phone !== phone);
    localStorage.setItem(ACCOUNT_LIST_KEY, JSON.stringify(accountList));
  } catch (error) {
    console.error("移除账号失败:", error);
  }
};

// 更新账号列表中的信息（根据 phone 更新 name）
export const updateAccountInList = (
  phone: string,
  updates: { name?: string; role?: string }
) => {
  try {
    let accountList = getAccountList();
    const accountIndex = accountList.findIndex((item) => item.phone === phone);

    if (accountIndex !== -1) {
      // 更新账号信息
      accountList[accountIndex] = {
        ...accountList[accountIndex],
        ...updates,
      };
      localStorage.setItem(ACCOUNT_LIST_KEY, JSON.stringify(accountList));
    }
  } catch (error) {
    console.error("更新账号信息失败:", error);
  }
};

export const getSystemConfig = () => {
  return (window as any).__APP_CONFIG__ || {};
};
export const getApiBaseUrl = () => {
  return getSystemConfig().apiBaseUrl;
};
